import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { FormControl } from '@material-ui/core';

import FormTextField from 'retired/FormTextField';
import makeSortableItem from 'retired/SortableItem';
import * as validators from 'utils/validators';

import SectionsSelector from './SectionsSelector';

const required = validators.required();

const Option = ({
  option,
  questionType,
  remove,
  sections,
  showNextSections,
  allowMultiple,
  isSurvey,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      paddingTop: 5,
      paddingBottom: 5,
    }}
  >
    <DragHandleIcon style={{ marginRight: 10 }} />
    {((questionType === 'MultipleChoice' && !allowMultiple) || questionType === 'NPSScale') && (
      <RadioButtonUncheckedIcon style={{ marginRight: 15 }} />
    )}
    {questionType === 'MultipleChoice' && allowMultiple && (
      <CheckBoxOutlineBlankIcon style={{ marginRight: 15 }} />
    )}
    <FormControl style={{ flexGrow: 1 }}>
      <Field
        name={`${option}.title`}
        component={FormTextField}
        placeholder="Option text"
        validate={required}
        required
      />
    </FormControl>
    <IconButton size="small" onClick={remove} title="Remove option">
      <ClearIcon size="small" />
    </IconButton>
    {showNextSections && (
      <FormControl style={{ marginLeft: 15, width: 300 }}>
        <Field
          name={`${option}.nextSection`}
          component={SectionsSelector}
          title="Next section"
          sections={sections}
          isSurvey={isSurvey}
        />
      </FormControl>
    )}
  </div>
);
Option.propTypes = {
  sections: PropTypes.object,
  option: PropTypes.string,
  questionType: PropTypes.string,
  showNextSections: PropTypes.bool,
  allowMultiple: PropTypes.bool,
  remove: PropTypes.func,
  isSurvey: PropTypes.bool,
};
export default makeSortableItem({ itemType: 'option' })(Option);
